export enum SYNC_STATUSES {
    Cancelled = "cancelled",
    Completed = "completed",
    Failed = "failed",
    Syncing = "syncing"
}
